import { render, staticRenderFns } from "./edit-cell.vue?vue&type=template&id=87f05514&scoped=true"
import script from "./edit-cell.vue?vue&type=script&lang=js"
export * from "./edit-cell.vue?vue&type=script&lang=js"
import style0 from "./edit-cell.vue?vue&type=style&index=0&id=87f05514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f05514",
  null
  
)

export default component.exports